(ns dashboard.components.browser-extension-bar
  (:require [clojure.string :as str]
            [re-frame.core :as rf]
            [reitit.frontend.easy :as rfe]
            [dashboard.subs :as subs]
            [dashboard.config :as config]
            [dashboard.views.browser-extension.client-environments.config :as client-envs-config]
            [dashboard.views.browser-extension.questionnaire-list.config :as questionnaire-list-config]
            [dashboard.views.browser-extension.questionnaire.config :as questionnaire-config]
            [dashboard.views.browser-extension.new-questionnaire.config :as new-questionnaire-config]
            [dashboard.browser-extension :as extension]))

(rf/reg-sub
 ::env-history
 (fn [db [_]]
   (get-in db [:browser-extension :env-history] [])))

(defn host->env [host]
  (cond
    (str/starts-with? host "localhost") "localhost"
    (str/ends-with? host config/APPLICATION_BASE_DOMAIN) (-> host (str/split #"\.") first)
    :else host))

(defn hide-for-route? [route]
  (let [hidden-routes-names #{client-envs-config/view-id}]
    (contains? hidden-routes-names (-> route :data :name))))

(defn jump-to-env [event]
  (let [env (.. event -target -value)]
    (rf/dispatch [::extension/send-event {:type :environment-selected
                                          :env env}])))

(defn back-action-url [route]
  (cond
    (let [current-route (-> route :data :name)]
      (or (= current-route questionnaire-config/view-id)
          (= current-route new-questionnaire-config/view-id)))
    {:url (rfe/href questionnaire-list-config/view-id)
     :title "Back to questionnaire list"}

    :else nil))

(defn browser-extension-bar []
  (let [route @(rf/subscribe [::subs/route])
        previous-envs @(rf/subscribe [::env-history])
        current-env (host->env (.. js/window.location -host))
        is-extension-expanded @(extension/is-extension-expanded)
        back-url (back-action-url route)]
    (when-not (or (hide-for-route? route)
                  (not is-extension-expanded))
      [:div.browser-extension-header
       (when-let [{:keys [url title]} back-url]
         [:a.button.is-light {:href url
                              :title title}
          [:span.icon>i.fas.fa-arrow-left]])
       [:div.select.is-flex.is-flex-grow-1>select.is-flex-grow-1
        {:default-value current-env
         :on-change jump-to-env
         :title "Jump to previously visited environment"}
        (map (fn [env]
               [:option {:key env :value env} env])
             (into #{} (cond-> previous-envs
                         current-env (conj current-env))))]
       [:a.button.is-light.has-text-weight-bold
        {:href (rfe/href client-envs-config/view-id)
         :title "Return to client environment selection, for logging into a new environment, that has not yet been visited"}
        [:span.icon>i.fas.fa-right-from-bracket]]])))
